"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SlidingScale = function SlidingScale(_ref) {
  var start = _ref.start,
      end = _ref.end,
      readOnly = _ref.readOnly,
      errMsg = _ref.errMsg;
  var rangeRef = (0, _react.useRef)();
  var pinBulletRef = (0, _react.useRef)();
  var centerValue = Math.round(end / 2);

  var _useState = (0, _react.useState)(window.innerWidth),
      width = _useState[0],
      setWidth = _useState[1];

  var context = (0, _themeUi.useThemeUI)();
  var theme = context.theme;
  (0, _react.useEffect)(function () {
    if (rangeRef && rangeRef.current) {
      var thumbWidth = theme.sizes[3];
      var off = (rangeRef.current.clientWidth - thumbWidth) / (parseInt(rangeRef.current.max) - parseInt(rangeRef.current.min));
      var px = (rangeRef.current.valueAsNumber - parseInt(rangeRef.current.min)) * off - pinBulletRef.current.clientWidth / 2.5 + thumbWidth / 2;
      pinBulletRef.current.style.left = px + 'px';
      pinBulletRef.current.style.top = -rangeRef.current.offsetHeight - 14 + 'px';
      pinBulletRef.current.innerHTML = rangeRef.current.value;
      rangeRef.current.addEventListener('input', function () {
        return changeValuePosition(thumbWidth, off);
      });
    }

    window.addEventListener('resize', updateWidth);
    return function () {
      return window.removeEventListener('resize', updateWidth);
    };
  }, [width]);

  var updateWidth = function updateWidth() {
    setWidth(window.innerWidth);
  };

  var changeValuePosition = function changeValuePosition(thumbWidth, off) {
    var px = (rangeRef.current.valueAsNumber - parseInt(rangeRef.current.min)) * off - pinBulletRef.current.clientWidth / 2.5 + thumbWidth / 2;
    pinBulletRef.current.innerHTML = rangeRef.current.value;
    pinBulletRef.current.style.left = px + 'px';
  };

  return (0, _themeUi.jsx)("div", {
    sx: {
      margin: 'auto',
      mt: 5,
      position: 'relative',
      'input[type=range]': {
        backgroundColor: 'secondaryLight',
        borderRadius: theme.radii.small,
        height: theme.borderWidths.regular + theme.borderWidths.xThick + "px",
        width: '100%',
        outline: 'none',
        cursor: 'pointer',
        '-webkit-appearance': 'none',
        pointerEvents: readOnly ? 'none' : 'auto',
        '&::-webkit-slider-thumb': {
          '-webkit-appearance': 'none',
          width: theme.sizes[3],
          height: theme.sizes[3],
          backgroundColor: 'primaryLight',
          borderRadius: theme.sizes[3],
          borderBottomRightRadius: 0,
          transform: 'rotate(45deg)',
          opacity: start && end ? 1 : 0,
          position: 'relative',
          top: -4
        },
        '::-moz-range-thumb': {
          '-webkit-appearance': 'none',
          width: theme.sizes[3],
          height: theme.sizes[3],
          backgroundColor: 'primaryLight',
          borderRadius: theme.sizes[3],
          borderBottomRightRadius: 0,
          transform: ' translateY(-70%) rotate(45deg)',
          opacity: start && end ? 1 : 0
        }
      }
    }
  }, (0, _themeUi.jsx)("input", {
    type: "range",
    min: start,
    max: end,
    defaultValue: centerValue,
    ref: rangeRef
  }), (0, _themeUi.jsx)("output", {
    ref: pinBulletRef,
    sx: {
      position: 'absolute',
      textAlign: 'center',
      minWidth: theme.sizes[4] / 2,
      minHeight: theme.sizes[4] / 2,
      backgroundColor: 'white',
      borderRadius: '50%',
      color: 'primaryLight',
      fontWeight: 'bold',
      opacity: start && end ? 1 : 0
    }
  }), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      justifyContent: 'space-between',
      pb: 2
    }
  }, (0, _themeUi.jsx)(_Text["default"], null, start || 0), (0, _themeUi.jsx)(_Text["default"], null, end || 0)), errMsg && (0, _themeUi.jsx)(_Text["default"], {
    sx: {
      color: 'alerts.error'
    }
  }, errMsg));
};

SlidingScale.propTypes = {
  start: _propTypes["default"].number,
  end: _propTypes["default"].number,
  readOnly: _propTypes["default"].bool,
  errMsg: _propTypes["default"].string
};
SlidingScale.defaultProps = {
  readOnly: false
};
var _default = SlidingScale;
exports["default"] = _default;